import { useSelector } from 'react-redux';
import profleStore from '@benniehealth/core-js/store/profile';
import { getHasActiveEnrollments } from '@app/store/profile/selectors';

const useTourState = () => {
  const hasActiveEnrollments = useSelector(getHasActiveEnrollments);
  const hasTakenBennieAppIntroTour = useSelector(
    profleStore.selectors.hasTakenBennieAppIntroTourSelector,
  );

  const canShowTour = hasActiveEnrollments;

  return { canShowTour, hasTakenBennieAppIntroTour };
};

export default useTourState;
